module.exports = __webpack_public_path__ + "static/media/racetrack.23ab3956.png";